import React from 'react'
import PropTypes from 'prop-types'
import { isNil } from 'lodash'
import { createUseStyles } from 'react-jss'
import { Hidden } from '@material-ui/core'

// import "./content.sass"

const useStyles = createUseStyles(theme => ({
    styles: {
        ...theme,
        color: theme.colors.coal,
        display: 'inline-block',
        position: 'relative',
        textDecoration: 'none',
        transition: 'all 0.3s ease-in-out',

        '@media (max-width: 600px)': {
            display: 'block',
            marginBottom: 5,
        },

        '&::before': {
            backgroundColor: theme.colors.ocean,
            bottom: -2,
            content: "''",
            height: 2,
            left: 0,
            position: 'absolute',
            transition: 'all 0.3s ease-in-out',
            width: 0,
            '@media (max-width: 600px)': {
                display: 'none',
            },
        },

        '&:hover': {
            color: theme.colors.ocean,
            textShadow: '1px 0 0 #02386b',
        },

        '&:hover::before': {
            width: '100%',
        },
    },
}))

export const FooterLink = ({ children, href }) => {
    const classes = useStyles()

    return (
        <a className={classes.styles} href={href}>
            {children}
        </a>
    )
}

FooterLink.propTypes = {
    children: PropTypes.node,
    href: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(undefined)]),
}

export default FooterLink
